module.exports = __webpack_public_path__ + "assets/img/hero_5.a3f59e53.png";